import React from 'react';
import User from './User'

class UserProfile extends User {

  getReturnButton() {
    return null
  }
}

export default UserProfile;



// WEBPACK FOOTER //
// ./src/components/UserProfile.js